import { render, staticRenderFns } from "./BoxContent5.vue?vue&type=template&id=1b8f703e&scoped=true"
import script from "./BoxContent5.vue?vue&type=script&lang=js"
export * from "./BoxContent5.vue?vue&type=script&lang=js"
import style0 from "./BoxContent5.vue?vue&type=style&index=0&id=1b8f703e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f703e",
  null
  
)

export default component.exports